/** Paleta fixa para distinguir agendas no calendário (Fase 4 UI). */
export const GCAL_CALENDAR_PALETTE = [
  "#6366f1",
  "#14b8a6",
  "#f97316",
  "#ec4899",
  "#0ea5e9",
  "#84cc16",
  "#8b5cf6",
  "#f43f5e",
  "#06b6d4",
  "#eab308",
] as const;

function hashCalendarId(calendarId: string): number {
  let hash = 0;
  for (let i = 0; i < calendarId.length; i++) {
    hash = (hash * 31 + calendarId.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function getCalendarAccentColor(
  calendarId: string | null | undefined,
  orderedCalendarIds?: string[],
): string | null {
  if (!calendarId) return null;

  if (orderedCalendarIds?.length) {
    const index = orderedCalendarIds.indexOf(calendarId);
    if (index >= 0) {
      return GCAL_CALENDAR_PALETTE[index % GCAL_CALENDAR_PALETTE.length];
    }
  }

  return GCAL_CALENDAR_PALETTE[hashCalendarId(calendarId) % GCAL_CALENDAR_PALETTE.length];
}

export interface SyncCalendarOption {
  id: string;
  calendar_id: string;
  display_name: string | null;
  is_primary: boolean;
  is_enabled?: boolean;
}

export function listEnabledSyncCalendars(
  connections: Array<{ syncCalendars: SyncCalendarOption[] }>,
  allowedGoogleCalendarIds: string[] | null,
): SyncCalendarOption[] {
  const enabled = connections.flatMap((conn) =>
    conn.syncCalendars.filter((sc) => sc.is_enabled !== false),
  );

  if (allowedGoogleCalendarIds === null) {
    return enabled;
  }

  const allowed = new Set(allowedGoogleCalendarIds);
  return enabled.filter((sc) => allowed.has(sc.calendar_id));
}

export function resolveDefaultSyncCalendarId(
  calendars: SyncCalendarOption[],
): string | null {
  if (calendars.length === 0) return null;
  const primary = calendars.find((c) => c.is_primary);
  return (primary ?? calendars[0]).id;
}

export function getSyncCalendarLabel(
  calendars: SyncCalendarOption[],
  syncCalendarId: string | null | undefined,
): string | null {
  if (!syncCalendarId) return null;
  const sc = calendars.find((c) => c.id === syncCalendarId);
  if (!sc) return null;
  return `${sc.display_name || sc.calendar_id}${sc.is_primary ? " (primária)" : ""}`;
}

export function getCalendarLabelByGoogleId(
  calendars: SyncCalendarOption[],
  googleCalendarId: string | null | undefined,
): string | null {
  if (!googleCalendarId) return null;
  const sc = calendars.find((c) => c.calendar_id === googleCalendarId);
  return sc?.display_name || googleCalendarId;
}
